import React from 'react';
import { Button, Alert, Label } from 'reactstrap';
import { ModalFooter, ModalBody } from 'reactstrap';
import { FieldArray } from 'formik';
import AddButton from '~/components/addButton/addButton';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import ProductOptions from '~/containers/productOptions/productOptions';
import TransferScheduleOptions from '~/containers/transferScheduleOptions/transferScheduleOptions';
import IconTooltip from '~/components/iconTooltip/iconTooltip';
import HelpIconTooltip from '~/components/helpIconTooltip/helpIconTooltip';
import { renderError, hasError } from '~/utils/formikValidation';
import { helpText } from './constants';

const LotModalFormMultiple = ({ values, errors, touched, handleSubmit, isSubmitting, onCancelClick }) => {
  const { products } = values;
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <ModalBody>
        <div className="flex mb3">
          <div className="flex-grow-1 mr3">
            <div>
              <div>
                <Label>When are you brewing?</Label>
                <FormikInputField type="date" name="startDate" invalid={!!errors.startDate} />
                {errors.startDate && (
                  <p data-qa="startDate-error" className="error">
                    {errors.startDate}
                  </p>
                )}
              </div>
            </div>
            <div className="mt3">
              <Label>How much (in litres)?</Label>
              <FormikInputField type="number" name="volume" invalid={!!errors.volume} />
              {errors.volume && (
                <p data-qa="volume-error" className="error">
                  {errors.volume}
                </p>
              )}
            </div>
          </div>
          <div>
            <div>
              <Label>What schedule?</Label>
              <FormikInputField type="select" name="transferScheduleId" invalid={!!errors.transferScheduleId}>
                <TransferScheduleOptions />
              </FormikInputField>
              {errors.transferScheduleId && (
                <p data-qa="transferScheduleId-error" className="error">
                  {errors.transferScheduleId}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="mb3">
          <div className="mb3 checkbox-container">
            <Label>
              <FormikInputField type="checkbox" name="isSample" checked={values.isSample} />
              Are these sample brews only?
              <HelpIconTooltip className="ml2" text={helpText} />
            </Label>
          </div>
        </div>
        <div className="mb3">
          <FieldArray
            name="products"
            validateOnChange={false}
            render={arrayHelpers => {
              return (
                <div>
                  <Label>Which products?</Label>
                  {products.map((product, idx) => {
                    return (
                      <div>
                        <div className="flex justify-end mb3">
                          <div className="flex-grow-1 flex">
                            <FormikInputField
                              className="flex-grow-1"
                              type="select"
                              name={`products.${idx}.id`}
                              invalid={hasError(errors, idx, 'products', 'id')}
                            >
                              <ProductOptions />
                            </FormikInputField>
                            <span className="dib mh2 self-center">x</span>
                            <FormikInputField defaultValue={1} className="w3" name={`products.${idx}.amount`} />
                          </div>
                          {products.length > 1 && (
                            <div className="flex self-center">
                              <IconTooltip
                                icon="delete-circle"
                                text="Remove ingredient"
                                className="ml3 stroke-brand-red"
                                onClick={() => arrayHelpers.remove(idx)}
                              />
                            </div>
                          )}
                        </div>
                        {renderError(errors, idx, 'products', 'id')}
                      </div>
                    );
                  })}
                  <AddButton
                    color="primary"
                    onClick={() =>
                      arrayHelpers.push({
                        id: null
                      })
                    }
                  >
                    Add another product
                  </AddButton>
                </div>
              );
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancelClick}>
          Cancel
        </Button>{' '}
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Schedule
        </SubmissionButton>
      </ModalFooter>
    </form>
  );
};

export default LotModalFormMultiple;



// WEBPACK FOOTER //
// ./src/components/lotModalForm/lotModalFormMultiple.jsx